import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import {
	AverageCalculateRequest,
	AverageCalculateResponse,
	CancelAverageMixRequest,
	ExecuteAverageMixRequest
} from "src/app/domain/interfaces/average-mix.interface";
import { IConfigurationCardOrTable } from "src/app/domain/interfaces/configuration-data.interface";
import { IResultTaxaMixData } from "src/app/domain/interfaces/proposal.interface";
import { ISelect } from "src/app/domain/interfaces/select.interface";
import { AverageMixService } from "src/app/domain/services/average-mix.service";
import { ClauseService } from "src/app/domain/services/clause.service";
import { EnviromentsService } from "src/app/domain/services/enviroments.service";
import { ProposalService } from "src/app/domain/services/proposals.service";
import { ParcelamentoPremioPropostaComponent } from "src/app/pages/components/parcelamento-premio-proposta/parcelamento-premio-proposta.component";
import { DialogComponent } from "../dialog/dialog.component";
import { LoadComponent } from "../load/load.component";
import { TipoDePropostaEnum } from "src/app/domain/enums/enums";

@Component({
	selector: "app-taxa-mix",
	templateUrl: "./taxa-mix.component.html",
	styleUrls: ["./taxa-mix.component.scss"]
})
export class TaxaMixComponent implements OnInit {
	@Input() taxaMixForm: UntypedFormGroup;
	@Input() listaTipoDeTaxaMix: any;
	@Input() listaTipoDeAplicacao: ISelect[];
	@Input() currentProposalI4Pro: any;
	@Input() currentProposalMarketplace: any;

	@Output() setTaxaMixResultados = new EventEmitter();
	@Output() removeTaxaMix = new EventEmitter();
	@ViewChild(ParcelamentoPremioPropostaComponent) parcelamento: ParcelamentoPremioPropostaComponent;
	taxaMixRadioControl = new UntypedFormControl();

	constructor(
		private averageMixService: AverageMixService,
		private datePipe: DatePipe,
		private dialog: MatDialog,
		private enviromentsService: EnviromentsService,
		private proposalService: ProposalService,
		protected activatedRoute: ActivatedRoute,
		private clauseService: ClauseService
	) {}

	//variaveis
	averageMixCalculateResponse: AverageCalculateRequest;
	executeAverageMixRequest: ExecuteAverageMixRequest;
	cancelAverageMixRequest: CancelAverageMixRequest;
	nomeBotaoTaxaMix = "SIMULAR";
	resultTaxaMixData: IResultTaxaMixData[] = [];
	resultTaxaMixCardOrTable: IConfigurationCardOrTable;
	comissaoRealizadoCalculo: any;
	type = Number(TipoDePropostaEnum[this.activatedRoute.snapshot.queryParams.listType]);
	mostarBotaoEfetivar = false;

	loadEnviromentsObj: any = [];

	ngOnInit(): void {
		this.resultTaxaMixCardOrTable = {
			displayedReference: [
				"taxa",
				"premio",
				"comissao",
				"diferencaPremioPercentual",
				"diferencaPremioValor",
				"diferencaComissao"
			],
			nameHeader: ["TAXA", "PRÊMIO", "COMISSÃO", "DIFERENÇA PRÊMIO %", "DIFERENÇA PRÊMIO R$", "DIFERENÇA COMISSÃO R$"],
			typeData: ["string", "string", "string", "string", "string", "string"],
			groupCard: [1, 2, 3, 4],
			buttons: []
		};

		this.disableFormFields();
		this.loadEnviroments();
	}

	loadEnviroments() {
		this.enviromentsService.GeAlltEnviroments().subscribe(res => {
			this.loadEnviromentsObj = res;
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.currentProposalI4Pro && changes.currentProposalI4Pro.currentValue) {
			if (changes.currentProposalI4Pro.currentValue.dados_garantia_vl_taxa_moeda)
				this.taxaMixForm.controls.taxa.setValue(changes.currentProposalI4Pro.currentValue.dados_garantia_vl_taxa_moeda);
			else
				this.taxaMixForm.controls.taxa.setValue(changes.currentProposalI4Pro.currentValue.dados_garantia_vl_taxa_risco);

			this.taxaMixForm.controls.importanciaSegurada.setValue(
				changes.currentProposalI4Pro.currentValue.dados_garantia_vl_is
			);
			this.taxaMixForm.controls.premio.setValue(changes.currentProposalI4Pro.currentValue.dados_garantia_vl_premio_net);
			this.taxaMixForm.controls.comissao.setValue(changes.currentProposalI4Pro.currentValue.dados_garantia_Vl_comissao);
			this.taxaMixForm.controls.comissaoOriginalI4Pro.setValue(
				changes.currentProposalI4Pro.currentValue.dados_garantia_Pe_comissao
			);
		}
		if (changes.currentProposalMarketplace && changes.currentProposalMarketplace.currentValue) {
			if (
				changes.currentProposalMarketplace.currentValue.averageMixId !== null &&
				changes.currentProposalI4Pro.currentValue.dv_premio_calculo_manual === 1
			) {
				this.taxaMixRadioControl.setValue(true);
				this.taxaMixForm.controls.calculado.setValue(true);
				this.taxaMixForm.controls.percentualTaxaMixAtual.setValue(
					changes.currentProposalMarketplace.currentValue.averageMixPercentual
				);
				this.taxaMixForm.controls.premio.setValue(changes.currentProposalMarketplace.currentValue.premioOriginal ?? 0);
				this.taxaMixForm.controls.comissao.setValue(
					changes.currentProposalMarketplace.currentValue.comissaoOriginal ?? 0
				);
				this.computeTaxaMix(false);
				this.taxaMixForm.controls.possuiTaxaMix.setValue(true);
			} else {
				this.taxaMixRadioControl.setValue(false);
				this.taxaMixForm.controls.possuiTaxaMix.setValue(false);
			}
			this.taxaMixForm.controls.inicioVigencia.setValue(
				this.datePipe.transform(changes.currentProposalMarketplace.currentValue.inicioValidade, "yyyy-MM-dd")
			);
			this.taxaMixForm.controls.terminoVigencia.setValue(
				this.datePipe.transform(changes.currentProposalMarketplace.currentValue.fimValidade, "yyyy-MM-dd")
			);
		}
	}

	disableFormFields(): void {
		this.taxaMixForm.controls.taxa.disable();
		this.taxaMixForm.controls.importanciaSegurada.disable();
		this.taxaMixForm.controls.premio.disable();
		this.taxaMixForm.controls.comissao.disable();
		this.taxaMixForm.controls.inicioVigencia.disable();
		this.taxaMixForm.controls.terminoVigencia.disable();
	}

	// changeTaxaMixState(event): void{
	// }

	selectTaxaMix(taxaMix): void {
		this.taxaMixForm.controls.tipoDeTaxaMix.setValue(taxaMix);
	}

	async computeTaxaMix(mostrarBotao = true) {
		this.nomeBotaoTaxaMix = "NOVA SIMULAÇÃO";
		let request;
		await this.montarTaxaMixRequest().then(res => {
			request = res;
		});
		this.averageMixService.calculate(request).subscribe(
			(response: AverageCalculateResponse) => {
				const calculatedAverageMix = response.data;
				this.resultTaxaMixData = [];
				this.comissaoRealizadoCalculo = calculatedAverageMix.porcentagemComissaoCalculada;
				this.montarCorpoRespostaTaxaMix(calculatedAverageMix);
				// Tabela com os cálculos da taxa mix.
				this.resultTaxaMixCardOrTable.dataSourceTable = new MatTableDataSource(this.resultTaxaMixData);
				this.resultTaxaMixCardOrTable.dataSourceCard = this.resultTaxaMixData;

				this.mostarBotaoEfetivar = mostrarBotao;

				const payload = {
					comissaoCalculo: this.comissaoRealizadoCalculo,
					resultTaxaMix: this.resultTaxaMixData[0]
				};
				this.setTaxaMixResultados.emit(payload);
			},
			err => {}
		);
	}

	async montarTaxaMixRequest(): Promise<AverageCalculateRequest> {
		let averageMixCalculateRequest: AverageCalculateRequest;
		averageMixCalculateRequest = {
			averageMixId: this.taxaMixForm.controls.tipoDeTaxaMixId.value,
			tipoTaxaMix: 0,
			//tipoTaxaMix: this.taxaMixForm.controls.tipoDeAplicacao.value,
			taxa: Number.parseFloat(this.taxaMixForm.controls.taxa.value),
			premio: this.currentProposalI4Pro.dados_garantia_vl_premio_net ?? 0,
			premioOriginal: this.currentProposalMarketplace.premioOriginal ?? 0,
			comissao: this.currentProposalI4Pro.dados_garantia_Vl_comissao ?? 0,
			percentualTaxaMix: Number.parseFloat(this.taxaMixForm.controls.percentual.value.toString().replace(",", ".")),
			is: this.taxaMixForm.controls.importanciaSegurada.value,
			prazo: this.currentProposalMarketplace?.diasDeVigencia,
			comissaoOriginalI4Pro: this.currentProposalMarketplace.comissaoOriginal ?? 0,
			calculado: this.taxaMixForm.controls.calculado.value ? this.taxaMixForm.controls.calculado.value : false,
			percentualTaxaMixAtual: this.taxaMixForm.controls.percentualTaxaMixAtual.value
				? this.taxaMixForm.controls.percentualTaxaMixAtual.value
				: "0"
		};

		return averageMixCalculateRequest;
	}

	montarCorpoRespostaTaxaMix(calculatedAverageMix): void {
		this.resultTaxaMixData.push({
			taxa: calculatedAverageMix.taxa,
			premio: calculatedAverageMix.premio,
			comissao: calculatedAverageMix.comissao,
			diferencaPremioPercentual: calculatedAverageMix.diferencaPremioPercentual,
			diferencaPremioValor: calculatedAverageMix.diferencaPremioValor,
			diferencaComissao: calculatedAverageMix.diferencaComissao,
			averageMixId: Number.parseInt(this.taxaMixForm.controls.tipoDeTaxaMixId.value),
			averageMixTipoAplicacao: 0,
			//averageMixTipoAplicacao: parseInt(this.taxaMixForm.controls.tipoDeAplicacao.value),
			averageMixPercentual: calculatedAverageMix.diferencaPremioPercentualDecimal,
			taxaDecimal: calculatedAverageMix.taxaDecimal,
			premioDecimal: calculatedAverageMix.premioDecimal,
			comissaoDecimal: calculatedAverageMix.comissaoDecimal,
			diferencaPremioPercentualDecimal: calculatedAverageMix.diferencaPremioPercentualDecimal,
			diferencaPremioValorDecimal: calculatedAverageMix.diferencaPremioValorDecimal,
			diferencaComissaoDecimal: calculatedAverageMix.diferencaComissaoDecimal
		});
	}

	showModalComputeTaxaMix() {
		const dialogRef = this.dialog.open(DialogComponent, {
			data: {
				title: "Atenção!",
				text: "Deseja efetivar a Simulação na Proposta? Ela irá sobrepor o cálculo do sistema legado"
			},
			height: "238px",
			width: "480px",
			disableClose: true
		});
		dialogRef.componentInstance.firstNameButton = "SIM";
		dialogRef.componentInstance.secondNameButton = "NÃO";
		dialogRef.componentInstance.eventFirstButton.subscribe(res => {
			this.efetivarSimulacao();
			if (this.parcelamento) {
				this.parcelamento.verificaParcelamento(this.resultTaxaMixData[0]?.premioDecimal);
			}
		});
	}

	showModal(title: string, text: string, firstNameButton: string, secondNameButton: string) {
		const dialogRef = this.dialog.open(DialogComponent, {
			data: { title, text },
			height: "238px",
			width: "480px"
		});
		dialogRef.componentInstance.firstNameButton = firstNameButton;
		dialogRef.componentInstance.secondNameButton = secondNameButton;
	}

	async efetivarSimulacao() {
		const loadRef = this.dialog.open(LoadComponent, {
			panelClass: "custom-modalbox",
			disableClose: true
		});

		let executeAverageMixRequest;
		await this.montarTaxaMixExecuteRequest().then(res => {
			executeAverageMixRequest = res;
		});

		this.averageMixService.execute(executeAverageMixRequest).subscribe(
			async (response: any) => {
				const proposalPutI4Pro = await this.putProposalIi4Pro();

				// Begin: Taxa Mix
				if (this.currentProposalI4Pro != null) {
					if (this.currentProposalI4Pro.dv_premio_calculo_manual === 1) {
						proposalPutI4Pro.dados_garantia_vl_premio_total = this.resultTaxaMixData[0].premioDecimal;
						proposalPutI4Pro.dados_garantia_vl_premio_tarifario = this.resultTaxaMixData[0].premioDecimal;
						proposalPutI4Pro.dados_garantia_vl_taxa_risco = this.resultTaxaMixData[0].taxaDecimal;
						proposalPutI4Pro.dv_calculo_manual = "true";
					}
				}
				// End: Taxa Mix

				if (this.type === 8) {
					this.proposalService.putProposalI4proAdiantamento(proposalPutI4Pro).subscribe(res => {
						if (res.result.cd_retorno === this.loadEnviromentsObj.requestCdRetorno.sucesso) {
							this.showModal("Sucesso", "Simulação efetivada com sucesso!", null, "OK");
							const payload = {
								comissaoCalculo: this.comissaoRealizadoCalculo,
								resultTaxaMix: this.resultTaxaMixData[0]
							};
							//this.taxaMixForm.controls.premio.setValue(this.resultTaxaMixData[0].premioDecimal);
							//this.taxaMixForm.controls.comissao.setValue(this.resultTaxaMixData[0].comissaoDecimal);
							this.setTaxaMixResultados.emit(payload);
							this.taxaMixForm.controls.possuiTaxaMix.setValue(true);
							this.mostarBotaoEfetivar = false;
						} else {
							this.showModal("Atenção", res.message, null, "OK");
						}
						loadRef.close();
					});
				} else {
					this.proposalService.putProposalI4pro(proposalPutI4Pro).subscribe(res => {
						if (res.value.cd_retorno === this.loadEnviromentsObj.requestCdRetorno.sucesso) {
							this.showModal("Sucesso", "Simulação efetivada com sucesso!", null, "OK");
							const payload = {
								comissaoCalculo: this.comissaoRealizadoCalculo,
								resultTaxaMix: this.resultTaxaMixData[0]
							};
							//this.taxaMixForm.controls.premio.setValue(this.resultTaxaMixData[0].premioDecimal);
							//this.taxaMixForm.controls.comissao.setValue(this.resultTaxaMixData[0].comissaoDecimal);
							this.setTaxaMixResultados.emit(payload);
							this.taxaMixForm.controls.possuiTaxaMix.setValue(true);
							this.mostarBotaoEfetivar = false;
						} else {
							this.showModal("Atenção", res.value.nm_retorno, null, "OK");
						}
						loadRef.close();
					});
				}
			},
			() => {
				loadRef.close();
			}
		);
	}

	async putProposalIi4Pro() {
		const proposalPutI4pro = {
			dt_inicio_vigencia: this.datePipe.transform(this.currentProposalMarketplace.inicioValidade, "yyyy-MM-dd"),
			dt_final_vigencia: this.datePipe.transform(this.currentProposalMarketplace.fimValidade, "yyyy-MM-dd"),
			cd_susep: this.currentProposalMarketplace.codigoSusep, //Broker
			id_endereco_tomador: this.currentProposalI4Pro.id_endereco_tomador,
			id_endereco_cliente: this.currentProposalI4Pro.id_endereco_segurado, // Segurdo IdEndereco Tabela Insured
			id_usuario: this.currentProposalMarketplace.idUsuario, // Broker Id USuario
			cd_status: this.loadEnviromentsObj.propostaStatus[0].statusCode,
			dados_cobranca_dt_vencimento_pparcela: this.currentProposalI4Pro.dados_cobranca_dt_vencimento_pparcela,
			dados_cobranca_dias_demais_pparcela: this.currentProposalMarketplace.dados_cobranca_dt_vencimento_pparcela
				? new Date(this.currentProposalMarketplace.dados_cobranca_dt_vencimento_pparcela).getDay()
				: "0",
			dados_cobranca_cd_forma_pagamento_pparcela: this.currentProposalI4Pro.dados_cobranca_cd_forma_pagamento_pparcela,
			dados_cobranca_cd_forma_pagamento: this.currentProposalI4Pro.dados_cobranca_cd_forma_pagamento_demais_parc,
			dados_cobranca_id_produto_parc_premio: this.currentProposalI4Pro.dados_cobranca_id_produto_parc_premio,
			dados_cobranca_id_periodo_pagamento: this.currentProposalI4Pro.dados_cobranca_id_periodo_pagamento,
			dados_garantia_id_produto_cobertura: this.currentProposalI4Pro.dados_garantia_id_produto_cobertura,
			dados_garantia_vl_premio_tarifario: this.resultTaxaMixData[0].premioDecimal,
			dados_garantia_pe_comissao: this.comissaoRealizadoCalculo,
			dados_garantia_vl_adicional: "0.00",
			dados_garantia_vl_is: this.currentProposalI4Pro.dados_garantia_vl_is,
			dados_garantia_cd_moeda: "0.00",
			dados_garantia_vl_taxa_risco: this.resultTaxaMixData[0].premioDecimal,
			dados_garantia_vl_premio_total: this.resultTaxaMixData[0].premioDecimal,
			dados_garantia_vl_iof: "0.00",
			objeto_segurado_nm_objeto_segurado: this.currentProposalI4Pro.objeto_segurado_nm_objeto_segurado,
			texto_trabalhista_anexo: "",
			id_apolice: this.currentProposalI4Pro.id_apolice,
			cd_usuario_inclusao: this.currentProposalI4Pro.cd_usuario_inclusao,
			dv_calculo_manual: "true"
		};
		await this.loadPayloadClauses().then(res => {
			res.forEach(element => {
				proposalPutI4pro.texto_trabalhista_anexo += element.text + "_";
			});
		});
		return proposalPutI4pro;
	}

	async loadPayloadClauses() {
		const clauses = [];
		this.currentProposalMarketplace.propostaAdiantamentoClausulas.forEach(async element => {
			await this.clauseService
				.getById(element.idClausula)
				.toPromise()
				.then(res => {
					clauses.push(res.data);
				});
		});
		return clauses;
	}

	async montarTaxaMixExecuteRequest(): Promise<ExecuteAverageMixRequest> {
		let averageMixExecuteRequest: ExecuteAverageMixRequest;
		averageMixExecuteRequest = {
			proposalId: this.currentProposalMarketplace.id,
			averageMixId: this.taxaMixForm.controls.tipoDeTaxaMixId.value,
			averageMixTipoAplicacao: 0,
			averageMixPercentual: Number.parseFloat(this.taxaMixForm.controls.percentual.value.toString().replace(",", ".")),
			cdSusepCorretor: this.currentProposalMarketplace.codigoSusep,
			idUsuarioCorretor: this.currentProposalMarketplace.idUsuario,
			vlPremioTotal: this.taxaMixRadioControl.value ? this.resultTaxaMixData[0].premioDecimal : 0,
			vlPremioTarifario: this.taxaMixRadioControl.value ? this.resultTaxaMixData[0].premioDecimal : 0,
			vlTaxaRisco: this.taxaMixRadioControl.value ? this.resultTaxaMixData[0].taxaDecimal : 0,
			calculoManual: this.taxaMixRadioControl.value,
			garantiaV1Iof: 0,
			idApolice: this.currentProposalMarketplace.idApolice,
			peComissao: this.taxaMixRadioControl.value ? this.comissaoRealizadoCalculo : 0,
			premio: this.taxaMixForm.controls.premio.value ?? 0,
			comissao: this.taxaMixForm.controls.comissao.value ?? 0,
			vlPremioTarifarioOriginal: this.currentProposalMarketplace.premioOriginal ?? 0,
			comissaoOriginalI4Pro: this.currentProposalMarketplace.comissaoOriginal ?? 0,
			idTipoDeProposta: this.type
		};

		return averageMixExecuteRequest;
	}

	async changeTaxaMix() {
		if (!this.taxaMixRadioControl.value && this.taxaMixForm.controls.possuiTaxaMix.value) {
			const loadRef = this.dialog.open(LoadComponent, {
				panelClass: "custom-modalbox",
				disableClose: true
			});

			let executeAverageMixRequest;
			await this.montarTaxaMixExecuteRequest().then(res => {
				executeAverageMixRequest = res;
			});

			this.averageMixService.execute(executeAverageMixRequest).subscribe(
				(response: any) => {
					this.currentProposalI4Pro.dv_premio_calculo_manual = 0;
					this.resultTaxaMixData = [];
					this.resultTaxaMixCardOrTable.dataSourceTable = new MatTableDataSource(this.resultTaxaMixData);
					this.resultTaxaMixCardOrTable.dataSourceCard = this.resultTaxaMixData;
					this.taxaMixForm.controls.calculado.setValue(false);
					this.taxaMixForm.controls.possuiTaxaMix.setValue(false);
					this.removeTaxaMix.emit(response);
					loadRef.close();
				},
				() => {
					loadRef.close();
				}
			);
		}
	}
}
